window.addEventListener('DOMContentLoaded', function () {
  console.log('ally2 start');
  console.log('ally2 end');
});

$(document).ready(function () {
  console.log("a11y2 ready start");

  const btn = document.querySelector('.collection-tabs-mobile .dropdown-trigger');

  if (btn) {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  }

  $('#shopify-section-template--26411595235647__604165ea-96cb-4625-8da7-c75ab47b52f2 .object-wrapper div.absolute img.media-style').attr('alt','');

  new MutationObserver(() => {
    document.querySelectorAll('img[src*="BG_2.svg"], img[srcset*="BG_2.svg"]')
      .forEach(img => img.alt = "");
  }).observe(document.body, { childList: true, subtree: true });

  $('.featured-collection .object-wrapper div[x-show] img').attr('alt','');

  function applyAriaLabels(scope) {
    $(scope).find('.product-tile').each(function () {
      const $tile = $(this);

      let name = $tile.find('.visually-hidden').first().text().trim();
      if (!name) {
        name = $tile.find('h3').text().trim();
      }

      const price = $tile.find('.price-item--regular').first().text().trim();
      const ariaLabel = name + ', Regular price ' + price;

      $tile.find('a.absolute').attr('aria-label', ariaLabel);
    });
  }

  applyAriaLabels('#shopify-section-template--26411593630015__product-grid');
  applyAriaLabels('#shopify-section-template--26411593695551__product-grid');
  applyAriaLabels('#shopify-section-template--26411593662783__37be5744-f57e-4b97-8f5d-3c83b5320bc3');

  const target = document.querySelector('#facets-results');

  if (target) {
    const observer = new MutationObserver(() => {
      applyAriaLabels(target);
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

$('.page-coffee-subscription #arise-signature-blend,.page-coffee-subscription #virtuosa-signature-blend,.page-coffee-subscription #ignite-signature-blend').attr('tabindex','-1');
new MutationObserver(() => {
  $('.oke-w-reviewMinimal-footer svg').attr({
    'role': 'img',
    'aria-label': 'Verified by shop'
  });
}).observe(document.body, {
  childList: true,
  subtree: true
});
$('ul li#slideshow-template--26411594055999__hero_Nexw8Y-slide01,#shopify-section-template--26411594055999__featured_collections_tabs_nBeYzW .collection-tab-panel.is-active #slideshow-template--26411594055999__featured_collections_tabs_nBeYzW-').removeAttr('role aria-label aria-roledescription');
function initSliderControl(wrapperSelector) {

  const $wrapper = $(wrapperSelector);

  const $slider = $wrapper.find('.ecom-swiper-container');

  const swiper = $slider[0]?.swiper;

  if (!$wrapper.length || !$slider.length || !swiper) return;

  const playIcon = `
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8 5v14l11-7z"></path>
    </svg>
  `;

  const pauseIcon = `
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 5h4v14H6zm8 0h4v14h-4z"></path>
    </svg>
  `;

  const $btn = $('<button>', {
    class: 'slider-toggle',
    type: 'button',
    'aria-label': 'Pause slider autoplay',
    'aria-pressed': 'false',
    html: pauseIcon
  });

  $wrapper.css('position', 'relative');

  $wrapper.append($btn);

  function updateUI() {

    if (swiper.autoplay.running) {

      $btn
        .html(pauseIcon)
        .attr('aria-label', 'Pause slider autoplay')
        .attr('aria-pressed', 'false');

    } else {

      $btn
        .html(playIcon)
        .attr('aria-label', 'Play slider autoplay')
        .attr('aria-pressed', 'true');
    }
  }

  $btn.on('click', function () {

    if (swiper.autoplay.running) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.start();
    }

    updateUI();
  });

  updateUI();
}

setTimeout(() => {

  initSliderControl('#ecom-taltha-logo-list');

}, 2000);

$('body').append(
  '<div id="form-status-announcer" aria-live="assertive" class="screen-reader-text"></div>'
);
new MutationObserver(() => {
  $('form .klaviyo-form-richtext').attr('role', 'alert');
  const btn = document.querySelector('.klaviyo-form button');
  if (btn && btn.disabled) {
    $('#form-status-announcer').text('Loading, please wait');
  }
}).observe(document.body, {
  subtree: true,
  attributes: true,
  attributeFilter: ['disabled']
});
$('#shopify-block-AUmszMGkrTmpscTVyL__ai_gen_block_b427614_TKphTk iframe').attr('title','Map showing Talitha Coffee Roasters location in San Diego');
const $form = $('.page-partnerships form.ecom-contact-form');
  $form.find('input[name="contact[first-name]"]').attr('autocomplete', 'given-name');
  $form.find('input[name="contact[last-name]"]').attr('autocomplete', 'family-name');
  $form.find('input[name="contact[email]"]').attr('autocomplete', 'email');
  $form.find('textarea[name="contact[message]"]').attr('autocomplete', 'off');
setTimeout(()=>{
const $form1 = $('.page-wholesale form.g-container');
  $form1.find('input[name="text"]').attr('autocomplete', 'given-name');
  $form1.find('input[name="text-2"]').attr('autocomplete', 'family-name');
  $form1.find('input[name="email"]').attr('autocomplete', 'email');
  $form1.find('input[name="phone"]').attr('autocomplete', 'tel');
  $form1.find('input[name="text-3"]').attr('autocomplete', 'organization');
  $form1.find('input[name="text-4"]').attr('autocomplete', 'url');
  $form1.find('textarea[name="textarea"]').attr('autocomplete', 'off');
  $('.page-wholesale form.g-container .message.success').attr('role','alert');
},1500)
setTimeout(()=>{
   $('.page-wholesale').append(
    '<div id="form-loading-announcer" aria-live="assertive" class="visually-hidden"></div>'
  );
  $('.page-wholesale form.g-container').on('submit', function () {
    const hasErrors = $(this).find('.has-error').length;
    if (!hasErrors) {
      $('#form-loading-announcer')
        .text('Loading, please wait');
    }});
},2000);
const style = document.createElement('style');
style.textContent = `
body #shopify-section-template--25396251001151__pf-da852c31 .sc-doOhAX.dfRERk a:focus-visible{
    outline: 5px auto -webkit-focus-ring-color !important;
    outline-offset:0px;
}
body #shopify-section-template--25396251001151__pf-da852c31 .sc-doOhAX.dfRERk b{display:block; margin-bottom:5px;}`;
document.head.appendChild(style);
document.querySelectorAll(
  '#shopify-section-template--25396251001151__pf-da852c31 .sc-doOhAX.dfRERk a'
).forEach(a => {
  if (!a.textContent.trim() && !a.children.length) {
    a.remove();
  }
});
$('input#Quantity-template--25396252016959__main-sticky,input#Quantity-template--25396251525439__main-sticky').attr('aria-label','Product quantity');
$('#shopify-section-template--25396251033919__custom_form_liquid_VWJqFH .wholesale-form h3,.page-partnerships .ecom-6db11ugjp8d h3,.page-partnerships .ecom-z6tdq7p6857 h3,.page-partnerships .ecom-o32b4g51p4n h3,.page-partnerships .ecom-udtlzx39bft h3,#shopify-section-template--25396254671167__image_with_text_alternative_mQUn3V h6.highlight-text,#shopify-section-template--25396254671167__image_with_text_alternative_VEtc8L h6.highlight-text').attr('role','none');
$('#shopify-section-template--25396251033919__7f488a4f-7c40-427a-84f1-20004637f898 h2,.page-collection #section-template--25396255064383__6d1326c0-b8b6-4665-b902-ad883b68302f h2').attr({'role':'heading','aria-level':'1'});
$('.page-partnerships .ecom-nqa7u6udfpr h3,.page-partnerships .ecom-njoahihc9fa h3,.page-partnerships .ecom-o2vif7s40w h3,.page-partnerships .ecom-jd1umexlr5q h3,#shopify-section-template--25396254671167__featured_collections_tabs_nBeYzW h5.collection-title').attr({'role':'heading','aria-level':'2'});
$('#section-template--25396251328831__image_with_text_overlay_atUj4E img').attr('alt','Talitha Coffee Hope Roasted logo');
$('.page-partnerships figure img').attr('alt','');
$('.page-cart .push-btn input').attr('role','link');
$(".page-article .article-page .card-container .mt-5 .-mx-2 ul").removeAttr('role');
$('.page-bankers-hill ul.grid-container-custom,.page-bankers-hill ul.grid-container-custom li').attr('role','presentation')
$('.page-barrio-logan-roastery .sc-djVWQC li.sc-epRwmx.foIZBL.pf-16_').wrapInner(
  '<a href="tel:+16195591830"></a>'
);
const menus = document.querySelectorAll(".right-menu_item, .left-menu_item");
document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
        menus.forEach(menu => {
            menu.classList.add("menu-closed");
        });
    }
});
menus.forEach(menu => {
    menu.addEventListener("focusin", () => {
        menu.classList.remove("menu-closed");
    });
});
new MutationObserver(() =>
  $('.featured-collection .splide__track').removeAttr('aria-live')
).observe(document.body, {
  childList: true,
  subtree: true
});

if (document.querySelector('.page-wholesale .wholesale-form h2')) {
  document.querySelector('.page-wholesale .wholesale-form h2').setAttribute('aria-hidden', 'true');
  document.querySelector('.page-wholesale .wholesale-form h2').insertAdjacentHTML('afterend', '<h2 class="sr-only">LET\'S WORK TOGETHER</h2>');
}
setTimeout(() => {
  $('.page-cart form#cart li[role="row"]').each(function () {
    const name = $(this).find('p.text-sm.lg\\:text-base').text().trim();
    const variant = $(this).find('p.text-xs.mt-1').text().trim();

    $(this).find('img.media-style').attr('alt', `${name} ${variant}`);
  });
  $('#shopify-section-template--25396251164991__9770567a-44d1-4f41-bb9a-d3001ca9fff0 img,#shopify-section-template--25396251164991__f33e2f71-5967-49bd-b058-d41aa77a8eb0 img,#shopify-section-template--25396251164991__1e5bf31f-76f3-488e-a2a7-687e7ca4dfa3 img,#shopify-section-template--25396251164991__14528820-54c0-40da-b52e-157fd83f8a8a img').attr('alt','');
}, 1000);

$('.page-partnerships .ecom-goxaokd9erl h3.ecom__heading').attr('aria-hidden','true');
$('.page-partnerships .ecom-goxaokd9erl .ecom-3mt8ws8tdf6 h3')
  .after('<h2 class="sr-only">Together We Brew Change</h2>');
$('.page-bankers-hill svg.bh-phone-icon,.page-barrio-logan-roastery svg.pf-17_,.page-clairemont svg.bh-phone-icon').attr({'role':'img','aria-label':'Phone'});

$('.page-barrio-logan-roastery svg.pf-15_').attr({'role':'img','aria-label':'Location'});
$('.page-barrio-logan-roastery svg.pf-19_').attr({'role':'img','aria-label':'Time'});
$('.page-partnerships .ecom-zsni4qk7gbi figure img').attr('alt','Partner organization logos supporting anti-human trafficking efforts, including AIM, IJM, A21, GRACE, and others.')
// 
const cartLogoObserver = new MutationObserver(() => {

  requestAnimationFrame(() => {

    const menuOpen = $('.drawer-transition-host').is(':visible');

    if (menuOpen) {

      $('.shopify-section-group-header-group.section-site-header')
        .removeAttr('aria-hidden');

      $('.site-header__logo-link')
        .attr('aria-hidden', 'true');

      $('#headerBorderWrap a[href="/cart"]')
        .attr('aria-hidden', 'true');

    } else {

      $('.site-header__logo-link')
        .removeAttr('aria-hidden');

      $('#headerBorderWrap a[href="/cart"]')
        .removeAttr('aria-hidden');

    }

  });

});

cartLogoObserver.observe(document.body, {
  subtree: true,
  attributes: true,
  attributeFilter: ['style']
});

if (window.innerWidth < 768) {

  const mobileCloseBtnObserver = new MutationObserver(() => {

    if (
      $('.drawer-transition-host').is(':visible') &&
      !$('.mobile-menu-close-btn').length
    ) {

      $('#left-drawer-slot').prepend(`
        <button
          type="button"
          class="mobile-menu-close-btn"
          aria-label="Close menu"
          onclick="
            Alpine.store('modals').leftDrawer.open = false;
            document.querySelector('#headerBorderWrap button.js-enabled')
              ?.setAttribute('aria-expanded','false');
          "
        >
          X
        </button>
      `);

    }

  });

  mobileCloseBtnObserver.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });

}


  console.log("a11y2 ready end");
});